import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_table = _resolveComponent("app-table")!

  return (_ctx.totalRows)
    ? (_openBlock(), _createBlock(_component_app_table, {
        key: 0,
        columns: _ctx.table.columns,
        rows: _ctx.rows,
        total: _ctx.totalRows,
        actions: _ctx.table.actions,
        onRefreshData: _ctx.onRefresh
      }, null, 8, ["columns", "rows", "total", "actions", "onRefreshData"]))
    : _createCommentVNode("", true)
}